import script from "./contactBox.vue?vue&type=script&setup=true&lang=js"
export * from "./contactBox.vue?vue&type=script&setup=true&lang=js"

import "./contactBox.vue?vue&type=style&index=0&id=042763dc&lang=scss&scoped=true"
import "./contactBox.vue?vue&type=style&index=1&id=042763dc&lang=css"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042763dc"]])

export default __exports__